import { useState, useEffect } from 'react';
import Footer from '../../../components/Footer/Footer';
import InnerNav from '../../../components/InnerNav/InnerNav';
import Zodiac from '../../../components/ZodiacSign/Zodiac';
import './Summer.scss';
import PlanetLinks from '../../../components/PlanetLinks/PlanetLinks';
import city from '../../../city.json'


const Summer = () => {
  const months = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];

  const [year, setYear] = useState(2025);
  const [location, setLocation] = useState("New Delhi");
  const [summerData, setSummerData] = useState(null);
  const [timeFormat, setTimeFormat] = useState("12");

  const [tempLocation, setTempLocation] = useState("Kolkata");
  const [suggestions, setSuggestions] = useState([]);

  const formatTime = (timeStr, formatType) => {
    if (!timeStr || typeof timeStr !== "string") return "N/A";
    const isAMPM = /AM|PM/i.test(timeStr.trim());
    let [time, modifier] = timeStr.trim().split(/[\s]+/);
    let [hours, minutes] = time.split(":").map(Number);

    if (isNaN(hours) || isNaN(minutes)) return "N/A";

    if (isAMPM) {
      modifier = modifier.toUpperCase();
      if (modifier === "PM" && hours < 12) hours += 12;
      if (modifier === "AM" && hours === 12) hours = 0;
    }

    if (formatType === "12") {
      const suffix = hours >= 12 ? "PM" : "AM";
      const hour12 = hours % 12 || 12;
      return `${String(hour12).padStart(2, "0")}:${String(minutes).padStart(2, "0")} ${suffix}`;
    } else if (formatType === "24") {
      return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
    } else {
      return timeStr;
    }
  };

  useEffect(() => {
    const fetchSummer = async () => {
      try {
        const res = await fetch(`https://core-c343.onrender.com/api/seasons?year=${year}&locationName=${encodeURIComponent(location)}`);
        const data = await res.json();
        if (data.seasons && data.seasons.Summer) {
          setSummerData(data.seasons.Summer);
        } else {
          setSummerData(null);
        }
      } catch (err) {
        console.error("Error fetching summer data:", err);
      }
    };

    fetchSummer();
  }, [year, location]);

  const changeYear = (offset) => setYear((prev) => prev + offset);
  const handleYearInput = (e) => {
    const val = parseInt(e.target.value);
    if (!isNaN(val)) setYear(val);
  };


  
      const handleChange = (e) => {
        const value = e.target.value;
        setTempLocation(value);
    
        // filter cities when user types
        if (value.length > 0) {
          const filtered = city.filter((c) =>
            c.city.toLowerCase().includes(value.toLowerCase())
          );
          setSuggestions(filtered.slice(0, 4)); // show only first 4 results
        } else {
          setSuggestions([]);
        }
      };
    
      const handleSelect = (cityName) => {
        setTempLocation(cityName);
        setSuggestions([]);
      };

  const currentDate = new Date();
  const formattedDate = currentDate.toISOString().split("T")[0];
  const readableDate = `${months[currentDate.getMonth()]} ${currentDate.getDate()}, ${currentDate.getFullYear()}`;
  const weekDay = currentDate.toLocaleDateString("en-US", { weekday: "long" });

  return (
    <div className="Summer-container">
      <InnerNav />
      <div className="Summer-content">
        <Zodiac />

        <div className="Summer-details">
          <div className="title">Summer Solstice</div>

          <div className="controls">
            <div className="mode-toggle">
              <button onClick={() => setTimeFormat("12")} className={timeFormat === "12" ? "active" : ""}>12 Hour</button>
              <button onClick={() => setTimeFormat("24")} className={timeFormat === "24" ? "active" : ""}>24 Hour</button>
              <button onClick={() => setTimeFormat("24Plus")} className={timeFormat === "24Plus" ? "active" : ""}>24 Plus</button>
            </div>

            <div className="location-date">
              <div className="input-with-icon">
                  <span className="icon">📍</span>
                  <input
                    type="text"
                    value={tempLocation}
                    onChange={handleChange}
                    placeholder="Enter location"
                  />
                  {suggestions.length > 0 && (
                    <ul className="dropdown">
                      {suggestions.map((c, idx) => (
                        <li key={idx} onClick={() => handleSelect(c.city)}>
                          {c.city}, {c.state}, {c.country}
                        </li>
                      ))}
                    </ul>
                  )}
                  </div>
              <input type="number" value={year} onChange={handleYearInput} />
              <button onClick={() => changeYear(-1)}>Prev Year</button>
              <button
                onClick={() => setYear(new Date().getFullYear())}
                disabled={year === new Date().getFullYear()}
              >
                Current Year
              </button>
              <button onClick={() => changeYear(1)}>Next Year</button>
            </div>
          </div>

          <div className="muhurta-section">
            <div className="muhurta-header">
              <div className="muhurta-date">{year} Summer Season</div>
            </div>

            {summerData ? (
              <div className="rahu-card">
                <div className="rahu-header">
                  <h3>Summer Season Begins</h3>
                  <p>{summerData.date} ({summerData.day})</p>
                </div>
                <div className="rahu-img">
                  <img src="https://www.pikpng.com/pngl/b/283-2831461_beach-png-beach-clipart-png-transparent-png.png" alt="Summer" />
                </div>
                <div className="rahu-data">
                  <h3>Time: {formatTime(summerData.time, timeFormat)}</h3>
                  <p>Timezone: {summerData.timezone}</p>
                  <p>Location: {summerData.location}</p>
                  <p>Coordinates: {summerData.coordinates.lat}, {summerData.coordinates.lon}</p>
                </div>
              </div>
            ) : (
              <p>Loading Summer Solstice data...</p>
            )}
          </div>
        </div>

        <PlanetLinks />
      </div>
      <Footer />
    </div>
  );
};

export default Summer;
